import { DataBagService } from '@/common/data-bag.service';
import { Injectable } from '@angular/core';
import { BannerElement, UpdateBannerPayload } from '../www-banner-list/www-banner-list.model';
import { Result } from '@/reservation/reservation.model';

@Injectable({
	providedIn: 'root',
})
export class WwwBannerApiService {
	constructor(private readonly dataBagService: DataBagService) {}

	getBanners(): Promise<Result<BannerElement>> {
		return new Promise((resolve, reject) => {
			this.dataBagService.get('/www/banner/?limit=999', (result, error) => {
				if (error) {
					reject(error);
				}

				resolve(result);
			});
		});
	}

	updateBanner(payload: UpdateBannerPayload): Promise<BannerElement> {
		return new Promise((resolve, reject) => {
			this.dataBagService.put('/www/banner/' + payload.id + '/', payload, (result, error) => {
				if (error) {
					reject(error);
				}

				resolve(result);
			});
		});
	}
}
